import React, {useContext, useEffect, useState } from "react";
import { Alert, Box, Grid, Typography } from '@deere/fuel-react';
import {QUESTION_NOT_APPLICABLE} from "../shared/Constants";
import {ReasonsContext} from './Ratings';

export const RatingNotApplicableView = ({criteria}) => {
    const [reason, setReason] = useState("");
    const reasons = useContext(ReasonsContext);

    useEffect(() => {
        if (criteria.notApplicableReason) {
                const reason = reasons.filter(item => item.id === criteria.notApplicableReason.reasonId).map(reason => reason.reason)
                setReason(reason)
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

    return (
        <Grid item xs={12}>
            <Box pl={8} pt={2} pb={2}>
                <Alert variant={"warning"}>
                    <Typography fontWeight="bold" component="span">
                        {QUESTION_NOT_APPLICABLE} : {reason}
                    </Typography>
                    <br/>
                    <Typography variant="label" component="span">
                        {criteria.notApplicableReason && criteria.notApplicableReason.updatedBy} | {criteria.notApplicableReason && criteria.notApplicableReason.comments}
                    </Typography>
                </Alert>
            </Box>
        </Grid>
    )
}